import { INLinkRouteProp } from '@components/INLink/types'
import { queryFn } from '@data/hooks/useExperimentParticipation'
import { getExperimentParticipationQueryKey } from '@data/queries/experiment/getExperimentQueryKey'
import { getPartialExperimentQueryOptions } from '@data/queries/experiment/getPartialExperimentQueryOptions'
import { ExperimentParticipationQueryKey } from '@data/queries/experiment/types'
import { catalogArray } from '@routes/utils/catalogArray'
import { isExperimentSatisfied } from '@routes/utils/isExperimentSatisfied'
import { useQueries } from '@tanstack/react-query'
import { uniq } from 'lodash-es'

const allKnownRouteExperimentNames = uniq(
    catalogArray.map((route) => route.definition.experiments?.allowSpaNav?.name).filter((route) => route != null)
)

/**
 * Query configs for all experiments
 */
const optionsForAllKnownRouteExperiments = allKnownRouteExperimentNames.map((experimentName) => {
    const options = getPartialExperimentQueryOptions<ExperimentParticipationQueryKey>(experimentName)
    const queryKey = getExperimentParticipationQueryKey(experimentName)

    return {
        ...options,
        queryKey,
        queryFn,
    }
})

/**
 * Will the user see an SPA page (as opposed to a classic site page) for the given URL, taking experiments into consideration?
 *
 * Returns true if the user will see the SPA page
 * Returns false if the user will see the classic site page
 */
export function useIsSpaAllowedAccordingToExperiment(routeToTest?: INLinkRouteProp): boolean {
    useQueries({ queries: optionsForAllKnownRouteExperiments })

    // This function may also be called with external URLs that do not have a documented route, so we return `false` to ensure they do not use SPA routing
    if (!routeToTest || typeof routeToTest === 'string') {
        return false
    }

    return isExperimentSatisfied(routeToTest)
}
